export default __webpack_public_path__ + "static/media/balloon1.e09c829b.png";